import React, { Fragment } from 'react';
import { useEffect, useState } from 'react'
import Button from '../common/ui-components/input/Button';
import styles from '../../styles/modules/components/SelfServe/select-service.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import {
    updateSelectedProblems,
    changeProgress,
    updateSelectedCover,
    changeTrackerState,
    changeIssuePageFrom,
    changeAddressPageFrom,
    updateAppointmentDate,
    pushToTicketList,
    resetSelectedProblems,
    previousStepProgress,
    resetUploadedDocumentRedux
} from '../../redux/actions/selfserveActions';
import { useDispatch } from 'react-redux';
import ReopenRequestAlert from './ReopenRequestModal';
import { connect } from 'react-redux';
import { planPageModal, selectService } from '../../tracking/selfserveTracking';
import DeviceDetail from '../../components/selfserve/DeviceDetail';
import { HOMECARE_PLANS, HOMECARE_PREMIUM_PRODUCTS, HOMECARE_PLAN_LIST } from '../../constants/index';
import CopayAlert from './CopayModal';
import { COPAY_EXEMPTED_COVERS, COPAY_EXEMPTED_PLAN_NAMES_WHILE_RISING_SR } from '../../constants/selfserve';
import router from 'next/router';
import { addAppRenderParams, isCopayAfterSr } from '../../utils/selfserve';
import { cleverTapTrigger } from '../../tracking/segment';

interface PlanCard {
    onClick: (e: React.MouseEvent) => void,
    style?: object,
    className?: string | null,
    children?: React.ReactNode,
    disabled?: boolean,
    service: any,
    planName: string,
    key: any,
    is_selected: Boolean,
    category: string
    noOfAvaliableCover: any,
    parentPlanDetails: any,
}


interface ReduxStateProps {

    selfserveReducer: any,
}

interface MainProps {
    setPageLoading: (data: Boolean) => void
}

type Props = ReduxStateProps & MainProps;

const SelectService = (props: Props) => {
    const [service] = useState(props.selfserveReducer.planCovers);
    const [reopenEligibleSR, changeReopenEligibleSR] = useState(false);
    const dispatch:any = useDispatch();
    const [isCopayPlan, setIsCopayPlan] = useState(false);
    const [planName] = useState(props.selfserveReducer.planDetails.hasOwnProperty('plan_title') ? props.selfserveReducer.planDetails.plan_title : '');
    const [copayAmount] = useState(props.selfserveReducer.planDetails.hasOwnProperty('copay_amount') ? props.selfserveReducer.planDetails.copay_amount : '');
    const copaymentscreenDamageAmount = props.selfserveReducer.planDetails.hasOwnProperty('copayment_screen_damage_amount') ? props.selfserveReducer.planDetails.copayment_screen_damage_amount : '';
    const copaymentReplacementAmount = props.selfserveReducer.planDetails.hasOwnProperty('copayment_replacement_amount') ? props.selfserveReducer.planDetails.copayment_replacement_amount : '';
    const copaymentAccessoriesAmount = props.selfserveReducer.planDetails.hasOwnProperty('copayment_accessories_amount') ? props.selfserveReducer.planDetails.copayment_accessories_amount : '';
    const hasProblemBasedCopay = props.selfserveReducer.planDetails.hasOwnProperty('has_problem_based_copay') ? props.selfserveReducer.planDetails.has_problem_based_copay : false;
    const isMultiCover = props.selfserveReducer.planCovers.length > 0 ? true:false
    const { current_ticket_key:currentTicketKey } = props.selfserveReducer


    const {
        previousStepList,
        parentPlanDetails,
        serviceRequests,
        coverCount,
        editScreen,
        deviceDetails,
        categoryDetails
    } = props.selfserveReducer

    useEffect(() => {

        props.setPageLoading(true);
        dispatch(changeTrackerState(2));
        window.scrollTo({top:0,left:0,'behavior': 'smooth'})
        dispatch(changeAddressPageFrom(4));
        dispatch(changeIssuePageFrom(4));

        const {
            planCovers,
            serviceRequests,
            parentPlanDetails,
            deviceDetails,
            planDetails,
        } = props.selfserveReducer

        cleverTapTrigger('Raise SR Covers Viewed', {'osid': planDetails?.osid, 'category': planDetails?.category, 'product_type': planDetails?.product_type})

        if (planCovers.length === 0) {


        } else {
            props.setPageLoading(false);
        }
        if(planCovers.length == 1 ){
            if(props.selfserveReducer.planDetails.is_copay){
                // hides copay alert popup while rising the sr
                let selectedCoverDetails = serviceRequests[0]?.selected_cover?.cover_details?.[0]
                if(!COPAY_EXEMPTED_COVERS.includes(selectedCoverDetails?.cover_title)
                    && !COPAY_EXEMPTED_PLAN_NAMES_WHILE_RISING_SR.includes(planDetails.plan_name)
                    && selectedCoverDetails?.is_cover_copay && !isCopayAfterSr(router)){
                    setTimeout(() => {
                        setIsCopayPlan(true)
                        planPageModal('Copay Modal', 'Plan Page'); //gtm trackign event
                    }, 2 * 1000)
                }
            }
        }
        if(serviceRequests[0].selected_cover && serviceRequests[0].selected_cover.cover_details[0].reopen == true){
            if (HOMECARE_PLANS.includes(parentPlanDetails.plan_name)) {
                const reopen_device_detail_ids = serviceRequests[0].selected_cover.cover_details[0].reopen_device_detail_ids
                if (reopen_device_detail_ids.includes(parseInt(deviceDetails.device_id))) {
                    changeReopenEligibleSR(true);
                }
            } else if (HOMECARE_PREMIUM_PRODUCTS.includes(parentPlanDetails.plan_name)) {
                const reopen_device_detail_ids = serviceRequests[0].selected_cover.cover_details[0].reopen_device_detail_ids
                if (reopen_device_detail_ids.includes(parseInt(deviceDetails.id))) {
                    changeReopenEligibleSR(true);
                }
            } else {
                changeReopenEligibleSR(true);
            }
        }
        dispatch(resetUploadedDocumentRedux())
    }, [])

    const handleClick = (item) => {
        if(props.selfserveReducer.serviceRequests[0].selected_cover && (item.cover_label !== props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0].cover_label)){

                    // This IF case handles if user comes to this step from IssuePage or AddressPage
                    // by Clicking Previous button and clicks on other cover than previously selected
                    // We will clear Redux State of Selected Issues Other wise it will append the issues
                    // of newly selected cover tomold Cover Issues

            dispatch(updateSelectedProblems({index: 0, selectedProblems: []}));
            if(!HOMECARE_PLAN_LIST.includes(parentPlanDetails.plan_name)){
                const appointmentData = {
                    appointment_date_1: null,
                    appointment_date_2: null,
                    appointment_slot_1: (new Date().getHours() < 14) ? "10AM - 2PM" : "2PM - 6PM",
                    appointment_slot_2: (new Date().getHours() < 14) ? "10AM - 2PM" : "2PM - 6PM",
                }
                dispatch(updateAppointmentDate(appointmentData));
            }
        }

        const data = {
            index: 0,
            selectedCover: [item]
        }

        dispatch(updateSelectedCover(data));
        if(HOMECARE_PLANS.includes(parentPlanDetails.plan_name)){
            if(item.reopen && deviceDetails.device_id && item.reopen_device_detail_ids.includes(parseInt(deviceDetails.device_id))){
                changeReopenEligibleSR(true)
            }
        }else if(HOMECARE_PREMIUM_PRODUCTS.includes(parentPlanDetails.plan_name)){
            if(item.reopen && deviceDetails.id && item.reopen_device_detail_ids.includes(parseInt(deviceDetails.id))){
                changeReopenEligibleSR(true)
            }
        }else{
            if (item.reopen){
                changeReopenEligibleSR(true)
            }
        }
        if(props.selfserveReducer.planDetails.is_copay){
            if(!COPAY_EXEMPTED_COVERS.includes(item.cover_title)
                && !COPAY_EXEMPTED_PLAN_NAMES_WHILE_RISING_SR.includes(props.selfserveReducer.planDetails.plan_name)
                && item.is_cover_copay && !isCopayAfterSr(router)){
                setIsCopayPlan(true)
                planPageModal('Copay Modal', 'Plan Page'); //gtm trackign event
            }
        }
    }
    const checkNoOfAvailableCover = (item) => {
        let totalService = item.no_of_total_service
        let claimsCover = item.no_of_claims
        let coverCountBeforeConsume = coverCount[item.cover_id]?.length || 0
        let availableCover = totalService - claimsCover - coverCountBeforeConsume

        return availableCover > 0 ? availableCover : 0
    }
    const isInvalidCover = (item) => {
        //cover title part check for hc plan

        if (HOMECARE_PLANS.includes(parentPlanDetails.plan_name)) {
            const deviceKey = `${parentPlanDetails.osid}-${deviceDetails.deviceKey}`
            const editCover = Object.keys(coverCount).map(
                (coverId) => coverCount.hasOwnProperty(coverId) && coverCount[coverId].includes(deviceKey)
                ? true : false).indexOf(true) != -1

            return checkNoOfAvailableCover(item) > 0 ? false : (editCover ? (props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0].cover_id == item.cover_id ? false : true) : true)
        }
        if(item.reopen || item.is_valid) {
            return false
        }
        return true
    }

    const handleButton = () => {
        const coverDetails = props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0]
        if (coverDetails.type == "non_service") {
            if (props.selfserveReducer.editScreen.isEditing) {
              dispatch(resetSelectedProblems())
            }
            dispatch(changeProgress(5, true));
        } else {
            const problemArray: any = [];
            problemArray.push(props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0].cover_label);
            const data: any = {
                index: 0,
                selectedProblems: problemArray
            }
            dispatch(updateSelectedProblems(data));
            //redirect deviceInformation page
            dispatch(pushToTicketList());
            if (HOMECARE_PLAN_LIST.includes(parentPlanDetails.plan_name)) {
                dispatch(changeProgress(15));
            } else if (coverDetails.upload_document_flag) {
                dispatch(changeProgress(19, true));
                dispatch(changeTrackerState(4));
            }
            else {
                dispatch(changeProgress(7));
            }
        }
        selectService(); //gtm tracking event
        cleverTapTrigger('Raise SR - Service Type Selected', {'cover':props.selfserveReducer?.serviceRequests[0]?.selected_cover?.cover_details[0].cover_label,'osid':props.selfserveReducer?.planDetails?.osid, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
    }
    const IsEnableNext = () => {
        let coverDetails = serviceRequests[0].selected_cover && serviceRequests[0].selected_cover.cover_details[0]
        if (HOMECARE_PLANS.includes(parentPlanDetails.plan_name)) {
            const reopen_device_detail_ids = coverDetails && coverDetails.reopen_device_detail_ids
            return reopen_device_detail_ids && !reopen_device_detail_ids.includes(deviceDetails.device_id) ? false : true;
        }else if(HOMECARE_PREMIUM_PRODUCTS.includes(parentPlanDetails.plan_name)){
            const reopen_device_detail_ids = coverDetails && coverDetails.reopen_device_detail_ids
            return reopen_device_detail_ids && !reopen_device_detail_ids.includes(deviceDetails.id) ? false : true;
        }else {
            return coverDetails && !coverDetails.reopen ? false : true
        }
        
    }
    return (
        <div className={styles.cover_parent}>
            <ReopenRequestAlert
                is_open={reopenEligibleSR}
                closeModal={changeReopenEligibleSR}
            />

            <div className={commonStyles.top_heading}><h5>Select a Service</h5></div>

            {props.selfserveReducer.landed_on_page === 'covers' &&
                <DeviceDetail />
            }

            <div className={styles.card_holder}>
                {service && service.map((item) => {
                    if (HOMECARE_PLANS.includes(parentPlanDetails.plan_name)) {
                        if (categoryDetails[deviceDetails.category_type].eligible_covers[parentPlanDetails.plan_name].find(i => i.root_type_cover === item.root_product_type_name)) {
                            return (
                                <ServiceCard
                                    key={item.cover_id}
                                    disabled={isInvalidCover(item)}
                                    planName={planName}
                                    category={props.selfserveReducer.deviceDetails?.category_type ? props.selfserveReducer.deviceDetails?.category_type : "device"}
                                    onClick={() => { handleClick(item) }}
                                    service={item}
                                    noOfAvaliableCover={checkNoOfAvailableCover(item)}
                                    parentPlanDetails={parentPlanDetails}
                                    is_selected={props.selfserveReducer.serviceRequests[0].selected_cover && props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0].cover_id == item.cover_id ? true : false} />
                            )
                        }
                    } else {
                        return (<ServiceCard
                            key={item.cover_id}
                            planName={planName}
                            disabled={isInvalidCover(item)}
                            category={props.selfserveReducer.planDetails.category_type}
                            onClick={() => { handleClick(item) }}
                            service={item}
                            parentPlanDetails={parentPlanDetails}
                            noOfAvaliableCover={checkNoOfAvailableCover(item)}
                            is_selected={props.selfserveReducer.serviceRequests[0].selected_cover && props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0].cover_id == item.cover_id ? true : false} />)
                    }
                })}
            </div>

            <div className={commonStyles.button_actions_sticky} data-varient='sticky'>
                {/* PREVIOUS BUTTON */}
                {previousStepList &&
                    <Button
                        className={commonStyles.cart_btn}
                        text={'Previous'}
                        variant='secondary'
                        onClick={() => {
                            if(router?.query?.app_render){
                                addAppRenderParams(router)
                            }else if(HOMECARE_PLANS.includes(parentPlanDetails.plan_name)){
                                dispatch(previousStepProgress(currentTicketKey));
                            }else{
                                router.push('/account/plans')
                            }
                        }}
                    />
                }
                <Button
                    disabled={IsEnableNext()}
                    className={commonStyles.cart_btn}
                    text={!editScreen.isEditing ? 'Next' : 'Done'}
                    variant='primary'
                    onClick={() => {handleButton()}}
                />

            </div>
            <CopayAlert  is_open={isCopayPlan} closeModal={setIsCopayPlan} planName={planName} isMultiCover={isMultiCover}copaymentscreenDamageAmount={copaymentscreenDamageAmount} copaymentReplacementAmount={copaymentReplacementAmount} copayAmount={copayAmount} copaymentAccessoriesAmount={copaymentAccessoriesAmount} hasProblemBasedCopay={hasProblemBasedCopay} copayDescription={props.selfserveReducer.planDetails.copay_description} copayDisclaimerNote={props.selfserveReducer.planDetails.copay_disclaimer_note} tokenizedOsid={props.selfserveReducer.planDetails.tokenized_osid}/>

        </div>
    )
}

const ServiceCard = (props: PlanCard) => {
    const service = props.service
    const category = props.category
    let label = '';
    let extraInfo = '';
    let classNameLapsed = false;
    let coverTextInfo = '';
    if (service.cover_title.includes('Preventive Maintenance')) {
        label = `Technician will visit your home for ${category}'s ${service.cover_title}`
    }
    if(HOMECARE_PLANS.includes(props.parentPlanDetails.plan_name)){
        let coverTextList = service.cover_text.split(" ")
        if(coverTextList.length > 1){
            coverTextList[0] = props.noOfAvaliableCover.toString()
        }
        coverTextInfo = coverTextList.join(" ")
    }else{
        coverTextInfo = service.cover_text
    }
    if (service.cover_title.includes('Service')) {
        label = `Technician will visit your home for ${category}'s ${service.cover_title}`
    }
    else if (service.cover_title == 'Breakdown') {
        label = `Technician will inspect the device, diagnose the problem and repair your ${category}`
    }
    else if (service.cover_title == 'Installation') {
        label = `Technician will install the ${category}. Any spare parts required will be charged`
    }
    else if (service.cover_title == 'Uninstallation') {
        label = `Technician will uninstall the ${category}. Installation at another location will be charged extra`
    }
    else if (['UV Kit', 'RO Kit'].includes(service.cover_title)) {
        label = `Our engineer will visit to install the new ${service.cover_title}`
    }else if (service.cover_title == 'Relocation') {

        if(service.cover_label == 'Get Uninstallation done'){

            label = `Our engineer will visit your place and get your device uninstallation completed`

        } else {

            label = `Our engineer will visit your place and get your device installation completed`

        }
    }else if (service.cover_title == 'Extended Warranty') {

        label = `We will repair your device with brand authorized service technicians`

    }else if (service.cover_title == 'Buy Back') {

        label = `We get your device picked up from your location and transfer eVouchers to your registered email ID and mobile number based on device condition`

    }
    else if (service.cover_title == 'Antivirus License') {
        label = ''
    }
    else if (service.cover_title == 'Totalcare') {
        label = 'We will repair your device with brand authorized service technicians'
    }

    if (!service.is_valid && service.last_sr_date) {
        if (service.cover_title == 'Breakdown') {

            extraInfo = `Breakdown support is availed already on ${service.last_sr_date}`
        }
        else if(props.planName == "AMC Gold" 
                && service?.cover_status=="ACTIVE"
                && service.cover_title == 'Preventive Maintenance'){
                extraInfo = `You have already utilised 2 ${service.cover_title} services in the current year.`
                classNameLapsed = true
            }
        else {

            extraInfo = `This service is availed already on ${service.last_sr_date}`
        }
    }
    else if (service.is_valid && service.last_sr_date) {

        if (service.cover_title == 'Breakdown') {

            extraInfo = `Breakdown support was recently provided on ${service.last_sr_date}`

        } else {

            extraInfo = `This service was recently provided on ${service.last_sr_date}`

        }
    }
    return (
        <Fragment>
            <div className={styles.app_btn} data-disabled={props.disabled} data-selected={props.is_selected ? props.is_selected : false} onClick={(e) => {
                e.preventDefault();
                !props.disabled ? props.onClick(e) : null;
            }}>
                <p className={styles.plan_header}>{service.cover_label}</p>
                <p className={styles.sub_text}>{label}</p>
                {/* red and green front css related part*/}
                {extraInfo && <p className={(extraInfo.includes('availed') || classNameLapsed) ? `${styles.extra_text} lapsed` : `${styles.extra_text} active`}>"{extraInfo}"</p>}
                {service.cover_text && props.parentPlanDetails.plan_name !== "HomeCare Fest" && <p
                    className={service.is_valid &&
                        !HOMECARE_PLANS.includes(props.parentPlanDetails.plan_name)
                        ? `${styles.extra_text} active`
                        : props.noOfAvaliableCover != 0
                            ? `${styles.extra_text} active`
                            : `${styles.extra_text} lapsed`}>
                    {coverTextInfo}
                </p>}
                {/* Confirm the message here */}
                {props.parentPlanDetails.plan_name === "Home Maintenance Plan" && service.cover_title === 'Breakdown' && <p
                    className={`${styles.extra_text} lapsed`}>
                    You will be charged at the time of service
                </p>}
            </div>
        </Fragment>
    );

}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(SelectService);
